// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container_button__F4PXB{
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .styles_button_next__eFa5V {
    background-color: #18316e !important;
    color: #ffffff !important;
    font-family: "Inter" !important;
    font-weight: 400 !important;
    padding: .4rem 1.5rem !important;
    text-transform: none !important;
    transition: all 0.3s ease !important;
  }
  
  .styles_button_next__eFa5V:hover {
    transform: scale(0.95) !important;
    opacity: 0.9;
  }`, "",{"version":3,"sources":["webpack://./src/components/CadastroDetalhado/DadosTitular/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,2BAA2B;IAC3B,gCAAgC;IAChC,+BAA+B;IAC/B,oCAAoC;EACtC;;EAEA;IACE,iCAAiC;IACjC,YAAY;EACd","sourcesContent":[".container_button{\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n  }\n\n  .button_next {\n    background-color: #18316e !important;\n    color: #ffffff !important;\n    font-family: \"Inter\" !important;\n    font-weight: 400 !important;\n    padding: .4rem 1.5rem !important;\n    text-transform: none !important;\n    transition: all 0.3s ease !important;\n  }\n  \n  .button_next:hover {\n    transform: scale(0.95) !important;\n    opacity: 0.9;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_button": `styles_container_button__F4PXB`,
	"button_next": `styles_button_next__eFa5V`
};
export default ___CSS_LOADER_EXPORT___;
